import { render, staticRenderFns } from "./nhyh.vue?vue&type=template&id=35179719"
import script from "./nhyh.vue?vue&type=script&lang=js"
export * from "./nhyh.vue?vue&type=script&lang=js"
import style0 from "./nhyh.vue?vue&type=style&index=0&id=35179719&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports